module.exports = __webpack_public_path__ + "img/06.60543a85.png";